import React from 'react';

export default function Times({ l, r, lr }){ return <>{(lr || l) ? ' ' : ''}⨉{(lr || r) ? ' ' : ''}</>; }
